/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import React, { useRef,useEffect } from 'react'
import { useGLTF, useAnimations } from '@react-three/drei'

export default function Model({ ...props }) {
  const group = useRef()
  const { nodes, materials, animations } = useGLTF('/RubberTube/tubeRope1.glb')
  const { actions } = useAnimations(animations, group)
  useEffect(() => {
    actions.Animation5.play();
    actions.Animation5.repetitions = 1;
    actions.Animation5.clampWhenFinished = true;
  }, [actions]);
  return (
    <group ref={group} {...props} dispose={null}>
      <group>
        <mesh name="rope1" geometry={nodes.rope1.geometry} material={materials.材質} />
      </group>
    </group>
  )
}

useGLTF.preload('/RubberTube/tubeRope1.glb')
